import { useCallback } from "react";
import { getTokenRegistryContract } from "../../utils/contractHelpers";
import Environment from "../../utils/Environment";
import useWeb3 from "../useWeb3";

const UseAddTokenAutomated = () => {
  const web3 = useWeb3();
  const contractAddress = Environment?.tokenRegistry;
  const tokenRegistryContract = getTokenRegistryContract(contractAddress, web3);

  const addTokenAutomated = useCallback(
    async (account, tokens, priceFeedData) => {
      if (!account || !tokens || !priceFeedData) return;
      try {
        console.log("Adding token with data:", { tokens, priceFeedData });

        const addTokenRes = await tokenRegistryContract.methods
          .setTokenPriceFeed(tokens, priceFeedData)
          .send({ from: account });

        console.log("Add token response: ", addTokenRes);
        return addTokenRes;
      } catch (err) {
        console.error(`Error adding token : `, err);
        throw err;
      }
    },
    [tokenRegistryContract]
  );

  return { addTokenAutomated };
};

export default UseAddTokenAutomated;
